
<svg width="24px" height="24px" viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <!-- Generator: Sketch 50.2 (55047) - http://www.bohemiancoding.com/sketch -->
    <desc>Created with Sketch.</desc>
    <defs></defs>
    <g id="Stockholm-icons-/-Layout-/-Layout-right-panel-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <rect id="bound" x="0" y="0" width="24" height="24"></rect>
        <rect id="Rectangle-7-Copy" fill="#000000" x="2" y="5" width="13" height="14" rx="1.5"></rect>
        <rect id="Rectangle-7-Copy-2" fill="#000000" opacity="0.3" x="17" y="5" width="5" height="14" rx="1"></rect>
    </g>
</svg>
